import { ActivityCategory } from '../types/activity.types.js';

export const ACTIVITY_CATEGORIES = [
  { value: ActivityCategory.NATURE, label: '自然 Nature', labelEN: 'Nature' },
  { value: ActivityCategory.MUSIC, label: '音乐 Music', labelEN: 'Music' },
  { value: ActivityCategory.DANCE, label: '舞蹈 Dance', labelEN: 'Dance' },
  { value: ActivityCategory.SPORTS, label: '体育 Sports', labelEN: 'Sports' },
  { value: ActivityCategory.ART, label: '艺术 Art', labelEN: 'Art' },
  { value: ActivityCategory.COOKING, label: '烹饪 Cooking', labelEN: 'Cooking' },
  { value: ActivityCategory.STEM, label: 'STEM', labelEN: 'STEM' },
  { value: ActivityCategory.OTHER, label: '其他 Other', labelEN: 'Other' },
] as const;
